export default "__VITE_ASSET__2BLYyTID__"